import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import * as moment from 'moment/moment';
import { Observable, ReplaySubject, Subject, forkJoin, zip, of, pipe, BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import {
    InteractService, ApiRequestService, UserInfoService, AppMetadataHandler, CommonUtilty
} from 'app'
//import { default as configData1 } from './search-vocabulary.component.json';
import { environment } from 'environments/environment';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { LookupDataService } from 'app/BaseFramework';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';

class SearchAPIMetaDataDO {
    key: any;
    keyDescription: any;
    valueInputType: any;
    lookupName: any;
    lookup: any;
    enable: any;
    isMandatory: Boolean;
}

const template = `
<nz-skeleton *ngIf="!configData" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="!configData">
</nz-skeleton>
<div *ngIf="configData">
</div>
`
// <div *ngIf="configData">
//     <search-configuration [configData]="configData" [transactionState]="transactionState"></search-configuration>
// </div>
@Component({
    selector: 'app-servicing',
    template: template,
    styleUrls: ['./servicing.component.scss'],
    providers: [TechnicalTranslatePipe]
})
export class ServicingComponent implements OnInit {
    public searchResultList = []
    public CRITERIALOOKUP = [];
    public dataSet = [];
    public intimationType = null
    public viewType = null

    constructor(private router: Router,
        private metadataService: MetadataService,
        private interactService: InteractService,
        private userInfoService: UserInfoService,
        private apiRequestService: ApiRequestService,
        private activatedRoute: ActivatedRoute,
        private commonUtilty: CommonUtilty,
        private technicalTranslatePipe: TechnicalTranslatePipe,
        public appMetadataHandler: AppMetadataHandler,
        public message: NzMessageService,
        private lookupDataService: LookupDataService) { }

    searchConfigurationForm: FormGroup
    SEARCHVOCABULARYFORMNAME = "searchConfigurationForm"
    configData
    pathFromRoot = [];
    transactionState = "search-policy";
    searchResultsList = [];

    payloadInEdit
    item

    vocabularyDetails: any = {};
    transactionModal = false;

    ngOnInit() {

        this.activatedRoute.data.subscribe(data => {
            this.extractTransactionFromPath();
            this.getConfigData()
        });
    }

    configPath = "/configs/policyServicing-transaction.json"
    getConfigData() {
        this.apiRequestService.get(this.configPath, null, true).subscribe(response => {
            this.configData = this.commonUtilty.deepCopy(response);
          })
    }

    extractTransactionFromPath() {

        if (this.commonUtilty.isArrayIterable(this.activatedRoute.pathFromRoot)) {
            this.activatedRoute.pathFromRoot.forEach(item => {
                if (item.routeConfig && item.routeConfig.path)
                    this.pathFromRoot.push(item.routeConfig.path);
            })
            this.transactionState = this.commonUtilty.isArrayIterable(this.pathFromRoot) ? this.pathFromRoot[2] : null;
            console.log("transactionState", this.transactionState);
        }
    }

 
}
